module.exports = __webpack_public_path__ + "img/contact-bg.c0762736.jpg";